import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * The chain of custody of one transport leg, oldest first.
 *
 * This is the only place a handover is readable: the leg row overwrites `pickedUpBy` when a carry
 * changes hands, so the driver who was replaced exists nowhere but here.
 */
export function useTransportOrderEvents(transportOrderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["transport-orders", guardString(transportOrderId), "events"],
		queryFn: async () => {
			const response = await client.stock["transport-orders"][":transportOrderId"].events.$get({
				param: { transportOrderId: guardString(transportOrderId) },
			});
			const data = await responseHandler(response);
			return data.events;
		},
		enabled: !!transportOrderId,
	});

	/** Return */
	return { ...query, events: query.data };
}
